import React from 'react';
import ReactDOM from 'react-dom';
import {Link, withRouter} from 'react-router';
import _ from 'lodash';
import moment from 'moment'

import {
  Row,
  Col,
  Icon,
  Grid,
  Panel,
  Table,
  PanelBody,
  PanelHeader,
  PanelFooter,
  FormControl,
  PanelContainer,
  FormGroup,
  ControlLabel,
  Form,
  Well,
  InputGroup,
  Button,
  ButtonGroup,
  ButtonToolbar,
  MenuItem,
  DropdownButton,
} from '@sketchpixy/rubix';
import {routeUrl} from '../routeUrl';
import Loader from 'react-loader';
import { 
    getRapaelClient,
    getRapaelClients,
    deleteContentClient,
    getContentMetas,
    getContentMeta,
    deleteContentMeta,
    getContentClients,
    getContentClient,
    inactivateContentClient,
    activateContentClient,
    inactivateContentMeta,
    activateContentMeta
} from '../../api/api';
import ServiceType from '../../constants/ServiceType';
import ApkEditModal from './components/ApkEditModal';
import ContentClientEditModal from './components/ContentClientEditModal';
import ContentMetaEditModal from './components/ContentMetaEditModal';

export default class ReleaseDetail extends React.Component {
  constructor(props) {
    super(props);

    const rapaelClientId = _.toNumber(props.params.rapaelClientId);
    this.state = {
       rapaelClientId: rapaelClientId,
       contentMetaId: null,
       contentClientId: null,
       rapaelClient: {
           downloadUrl: '',
           serviceTypeDto: {
               serviceTypeDisplayName: ''
           }
       },
       contentMetas: [],
       contentClients: [],
       showContentMetaEditModal: false,
       showContentClientEditModal: false,
    };
    
    this.loadInitData = this.loadInitData.bind(this);
  }

  componentDidMount() {
      this.loadInitData();
  }

  loadInitData() {
      if(this.state.rapaelClientId)
      {
         getRapaelClient(this.state.rapaelClientId, (err, result) => {
            if (err) {
              vex.dialog.alert('can not get release info.');
              this.goBack();
              return;
            } else {
                this.setState({
                  rapaelClient: result.client,
                });

                getContentMetas(this.state.rapaelClientId, (err, result) => {
                    if (err) {
                      vex.dialog.alert('can not get Content Meta.');
                      this.goBack();
                      return;
                    } else {
                        this.setState({
                           contentMetas: result.result,
                        });
                    }
                });
                
                
                getContentClients(this.state.rapaelClientId, (err, result) => {
                    if (err) {
                      vex.dialog.alert('can not get Content Meta.');
                      this.goBack();
                      return;
                    } else {
                        this.setState({
                           contentClients: result.result,
                        });
                    }
                });
            }
        });
     }
  }

  addContentMeta= (evt) => {
      this.setState({
         showContentMetaEditModal: true,
         rapaelClientId: this.state.rapaelClientId,
         contentMetaId: null
      });
  }

  editContentMeta = (contentMetaId) => {
      this.setState({
          showContentMetaEditModal: true,
          contentMetaId: contentMetaId
      });
  }
  
  deleteContentMeta = (contentMetaId) => {
      let self = this;
         vex.dialog.confirm({
            message: 'Are you sure to delete this item?',
            callback: function (value) {
                if (value) {
                    deleteContentMeta(contentMetaId, (err, res) => {
                        if (err) {
                            vex.dialog.alert('Failed to delete content!');
                          } else {
                            vex.dialog.alert('Content Deleted!');
                            self.loadInitData();
                          }
                    });
                } else {
                    console.log('delete cancel')
                }
            }
        });
  }

  closeContentMetaEditModal = (release = null) => {
    this.setState({
       showContentMetaEditModal: false,
    });
  };

  addContentClient= (evt) => {
      this.setState({
         showContentClientEditModal: true,
         rapaelClientId: this.state.rapaelClientId,
         contentClientId: null
      });
  }

  editContentClient = (contentClientId) => {
      this.setState({
          showContentClientEditModal: true,
          contentClientId: contentClientId
      });
  }
  
  deleteContentClient = (contentClientId) => {
      let self = this;
         vex.dialog.confirm({
            message: 'Are you sure to delete this item?',
            callback: function (value) {
                if (value) {
                    deleteContentClient(contentClientId, (err, res) => {
                        if (err) {
                            vex.dialog.alert('Failed to delete content!');
                          } else {
                            vex.dialog.alert('Content Deleted!');
                            self.loadInitData();
                          }
                    });
                } else {
                    console.log('delete cancel')
                }
            }
        });
  }

  closeContentClientEditModal = (release = null) => {
    this.setState({
       showContentClientEditModal: false,
    });
  };


  activateContentMeta = (contentMetaId) => {
    let self = this;
    activateContentMeta(contentMetaId, (err, res) => {
        if (err) {
            vex.dialog.alert('Failed to activate!');
        } else {
            vex.dialog.alert('Activated!');
            self.loadInitData();
        }
    });
  }

  inactivateContentMeta = (contentMetaId) => {
      let self = this;
        inactivateContentMeta(contentMetaId, (err, res) => {
            if (err) {
                vex.dialog.alert('Failed to activate!');
            } else {
                vex.dialog.alert('Inactivated!');
                self.loadInitData();
            }
        });
  }

  

  activateContentClient = (contentClientId) => {
    let self = this;
    activateContentClient(contentClientId, (err, res) => {
        if (err) {
            vex.dialog.alert('Failed to activate!');
        } else {
            vex.dialog.alert('Activated!');
            self.loadInitData();
        }
    });
  }

  inactivateContentClient = (contentClientId) => {
      let self = this;
        inactivateContentClient(contentClientId, (err, res) => {
            if (err) {
                vex.dialog.alert('Failed to activate!');
            } else {
                vex.dialog.alert('Inactivated!');
                self.loadInitData();
            }
        });
  }
  
  goBack = (e) => {
    this.props.router.push(`${routeUrl.releaseMgnt}`);
  };

  render() {
    return (
      <Grid>
          <Row>
            <Col sm={12}>
              <PanelContainer controls={false}>
                <Panel>
                  <PanelHeader className="bg-pinkishred fg-white">
                    <Grid>
                      <Row>
                        <Col xs={12}>
                          <h3>
                            Release Detail
                          </h3>
                        </Col>
                      </Row>
                    </Grid>
                  </PanelHeader>
                  <PanelBody style={{padding: 25}}>
                    <Grid>
                      <Row>
                        <Col xs={12}>
                          <Well>
                            <Form horizontal>
                                <FormGroup controlId='serviceType'>
                                    <Col sm={2} componentClass={ControlLabel}>Service Type</Col>
                                    <Col sm={10}>
                                        <FormControl type='text' placeholder='Service Type' value={this.state.rapaelClient.serviceTypeDto.serviceTypeDisplayName} readOnly/>
                                    </Col>
                                </FormGroup>
                                <FormGroup controlId='downloadUrl'>
                                    <Col sm={2} componentClass={ControlLabel}>APK File</Col>
                                    <Col sm={10}>
                                        <FormControl type='text' placeholder='APK File' value={this.state.rapaelClient.downloadUrl.split('/').pop()} readOnly/>
                                    </Col>
                                </FormGroup>
                                <FormGroup controlId='packageName'>
                                    <Col sm={2} componentClass={ControlLabel}>Package Name</Col>
                                    <Col sm={10}>
                                        <FormControl type='text' placeholder='Package Name' value={this.state.rapaelClient.packageName} readOnly/>
                                    </Col>
                                </FormGroup>
                                <FormGroup controlId='versionName'>
                                    <Col sm={2} componentClass={ControlLabel}>Version Name</Col>
                                    <Col sm={10}>
                                        <FormControl type='text' placeholder='Version Name' value={this.state.rapaelClient.versionName} readOnly/>
                                    </Col>
                                </FormGroup>
                                <FormGroup controlId='versionCode'>
                                    <Col sm={2} componentClass={ControlLabel}>Version Code</Col>
                                    <Col sm={10}>
                                        <FormControl type='text' placeholder='Version Code' value={this.state.rapaelClient.versionCode} readOnly/>
                                    </Col>
                                </FormGroup>
                                <FormGroup controlId='modifier'>
                                    <Col sm={2} componentClass={ControlLabel}>Modifier</Col>
                                    <Col sm={10}>
                                        <FormControl type='text' placeholder='Modifier' value={moment(this.state.rapaelClient.updatedTime).format('llll')} readOnly/>
                                    </Col>
                                </FormGroup>
                            </Form>
                          </Well>
                        </Col>
                      </Row>

                      <Row>
                      <Col xs={12}  className='text-right'>
                        <ButtonToolbar className='inbox-toolbar'>
                          <ButtonGroup>
                            <Button bsStyle='info' onClick={this.addContentClient}><Icon glyph='icon-fontello-doc-new'/></Button>
                          </ButtonGroup>
                        </ButtonToolbar>
                      </Col>
                   </Row>
                   <Row>
                     <Col xs={12}>
                       <Table ref="contentClientTables" className='display' cellSpacing='0' width='100%'>
                         <thead>
                           <tr>
                             <th>Package</th>
                             <th>Version Name</th>
                             <th>Version Code</th>
                             <th>Updated Time</th>
                             <th>Actions</th>
                           </tr>
                         </thead>
                         <tbody>
                           {
                           this.state.contentClients.map( (contentClient, index)=> (
                               <tr key={index}>
                                 <td>{contentClient.packageName}</td>
                                 <td>{contentClient.versionName}</td>
                                 <td>{contentClient.versionCode}</td>
                                 <td>{moment(contentClient.updatedTime).format('llll')}</td>
                                 <td>
                                      {contentClient.contentClientActivation === 1 ? (
                                         <Button bsStyle='success'  onClick={(event) => this.inactivateContentClient(contentClient.contentClientId)}>Inactivate</Button>
                                       ) : (
                                         <Button bsStyle='success'  onClick={(event) => this.activateContentClient(contentClient.contentClientId)}>Activate</Button>
                                       )}
                                    <Button bsStyle="info" onClick={(event) => this.editContentClient(contentClient.contentClientId)}>Edit</Button>
                                    <Button bsStyle="danger" onClick={(event) => this.deleteContentClient(contentClient.contentClientId)}>Delete</Button>
                                 </td>
                               </tr>
                           ))
                         }
                         </tbody>
                       </Table>
                       <br />
                     </Col>
                   </Row>


                      <Row>
                         <Col xs={12}  className='text-right'>
                           <ButtonToolbar className='inbox-toolbar'>
                             <ButtonGroup>
                               <Button bsStyle='info' onClick={this.addContentMeta}><Icon glyph='icon-fontello-doc-new'/></Button>
                             </ButtonGroup>
                           </ButtonToolbar>
                         </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                          <Table ref="contentMetaTables" className='display' cellSpacing='0' width='100%'>
                            <thead>
                              <tr>
                                <th>Content Id</th>
                                <th>APK</th>
                                <th>Updated Time</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                              this.state.contentMetas.map( (contentMeta, index)=> (
                                  <tr key={index}>
                                    <td>{contentMeta.contentId}</td>
                                    {
                                       contentMeta.contentClientDto
                                         ? <td>{contentMeta.contentClientDto.packageName}/{contentMeta.contentClientDto.versionName}/{contentMeta.contentClientDto.versionCode}</td>
                                         : <td></td>
                                    }
                                    <td>{moment(contentMeta.updatedTime).format('llll')}</td>
                                    <td>
                                         {contentMeta.contentMetaActivation === 1 ? (
                                            <Button bsStyle='success'  onClick={(event) => this.inactivateContentMeta(contentMeta.contentMetaId)}>Inactivate</Button>
                                          ) : (
                                            <Button bsStyle='success'  onClick={(event) => this.activateContentMeta(contentMeta.contentMetaId)}>Activate</Button>
                                          )}
                                       <Button bsStyle="info" onClick={(event) => this.editContentMeta(contentMeta.contentMetaId)}>Edit</Button>
                                       <Button bsStyle="danger" onClick={(event) => this.deleteContentMeta(contentMeta.contentMetaId)}>Delete</Button>
                                    </td>
                                  </tr>
                              ))
                            }
                            </tbody>
                          </Table>
                          <br />
                        </Col>
                      </Row>
                    </Grid>
                  </PanelBody>
                   <PanelFooter className='bg-pinkishred'>
                    <Grid>
                      <Row>
                        <Col xs={12} className='fg-white'>
                          <div style={{marginTop: '15px', marginBottom: '15px', float: 'right'}}>
                            <Button bsStyle='brownishgray' onClick={this.goBack} style={{marginRight: '8px'}}>List</Button>
                          </div>
                        </Col>
                      </Row>
                    </Grid>
                  </PanelFooter>
                </Panel>
              </PanelContainer>
            </Col>
          </Row>
          <ContentClientEditModal
          showModal={this.state.showContentClientEditModal}
          closeModal={this.closeContentClientEditModal}
          rapaelClientId={this.state.rapaelClientId}
          contentClientId={this.state.contentClientId}
          />
          <ContentMetaEditModal
          showModal={this.state.showContentMetaEditModal}
          closeModal={this.closeContentMetaEditModal}
          rapaelClientId={this.state.rapaelClientId}
          contentMetaId={this.state.contentMetaId}
          />
        </Grid>
    );
  }
}




// WEBPACK FOOTER //
// ./src/routes/ReleaseMgnt/ReleaseDetail.js